import { defineRouter } from '#q-app'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { Notify } from 'quasar'
import { useAccountStore } from '@/stores/account'

import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
  })

  Router.beforeEach((to, from, next) => {
    if (window.location.origin === 'https://ops.yeply.com' && to.name !== 'Login') {
      next({ name: 'Login' })
      return
    }

    const requiresFinance = to.meta.requiresFinance as boolean | undefined
    if (requiresFinance && !useAccountStore().account?.is_finance) {
      Notify.create({
        type: 'warning',
        message: 'Finance access required for invoices.',
      })
      next({ path: '/' })
    } else {
      next()
    }
  })

  return Router
})
